
<template>
  <div class='toastr-overlay'>
    <Toast
        v-for="toastr in toasts"
        :key="toastr.id"
        :id="toastr.id"
        :title="toastr.title"
        :message="toastr.message"
        :type="toastr.type"
        :timeout="toastr.options.timeout"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Toast from './Toastr.vue';

export default {
  components: { Toast },
  computed: {
    ...mapState('toastr', ['items']),
    toasts() {
      return this.items;
    }
  },
};
</script>

<style scoped>
.toastr-overlay {
  position: absolute;
  z-index: 1000;
  top: 20px;
  align-self: center;
  max-width: 420px;
  background-color: transparent;
}
@media screen and (max-width: 500px) {
  .toastr-overlay {
    top: 20px;
    right: 20px;
  }
}
</style>
